import React from 'react';

export const mapProps = mapper => BaseComponent => props => (
  <BaseComponent {...mapper(props)} />
);

export const withProps = input => BaseComponent => props => (
  <BaseComponent
    {...props}
    {...(typeof input === 'function' ? input(props) : input)}
  />
);
